<template>
  <header class="navbar" v-if="!appWebview">
    <div class="container">
      <div class="navbar-brand">
        <img src="@/assets/logo.svg" :alt="$t('navbar_logo_alt_text')" height="50" width="150">
      </div>
      <div class="d-none d-sm-block">
        <a class="btn btn-outline-primary" :href="$t('navbar_right_button_link')" target="_blank">
          {{ $t('navbar_right_button_text') }}
        </a>
      </div>
    </div>
  </header>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  name: 'NavBar',
  props: [
    'appWebview'
  ]
});
</script>

<style scoped lang="scss">
.navbar {
  height: 80px;

  background-color: #FFF;
  box-shadow: 0 3px 8px rgba(32, 91, 101, 0.2);
}

.navbar-brand img {
  height: 50px;
  width: 100%;
}

.btn {
  color: $color-dark;
}
</style>
